import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f2b2eed"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "financial-settlement"
};
import SearchForm from './components/SearchForm.vue';
import SettlementTable from './components/SettlementTable.vue';
import { getAccountBillList } from '@/api/billApi';
import { message } from 'ant-design-vue';
import { OK } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const searchFormRef = ref();
    const tableRef = ref();
    const loading = ref(false);
    const tableData = ref([]);
    const searchParams = ref();
    const activeBillStage = ref('FORMAL');
    const pagination = ref({
      current: 1,
      pageSize: 20,
      total: 0,
      showSizeChanger: true,
      showQuickJumper: false
    });
    const allAccountList = ref([]);
    const VALID_SORT_FIELDS = ['balance', 'estimatedSalesAmount', 'estimatedCommissionAmount', 'estimatedVatAmount', 'estimatedRevenue', 'salesAmount', 'commissionAmount', 'vatAmount', 'actualInvoiceAmount', 'actualReceivedAmount', 'expectReceivedAmount', 'receivedDiff', 'collectionSubject', 'withholdingTax', 'adjustment'];
    const isAccountBillSortField = sortField => VALID_SORT_FIELDS.some(field => field === sortField);
    const toSearchParams = formData => ({
      startMonthDate: formData.startMonthDate,
      endMonthDate: formData.endMonthDate,
      accountIdList: [...formData.accountId],
      payChnl: formData.payChnl,
      isNeedExternalSettlement: formData.isNeedExternalSettlement,
      currency: formData.currency,
      receivedStatus: formData.receivedStatus
    });
    const clearTableData = () => {
      tableData.value = [];
      pagination.value.total = 0;
    };
    const clearTableState = () => {
      var _tableRef$value;
      pagination.value.current = 1;
      if (searchParams.value) {
        delete searchParams.value.sortField;
        delete searchParams.value.ascending;
      }
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.clearSelection();
      clearTableData();
    };
    let latestRequestId = 0;
    const loadAccountBills = async () => {
      if (!searchParams.value) return;
      const requestId = ++latestRequestId;
      loading.value = true;
      try {
        const params = {
          ...searchParams.value,
          billStage: activeBillStage.value,
          pageNum: pagination.value.current,
          pageSize: pagination.value.pageSize
        };
        const res = await getAccountBillList(params);
        if (requestId !== latestRequestId) return;
        if (res && res.code === OK) {
          tableData.value = res.data.list;
          pagination.value.total = res.data.total;
        } else {
          clearTableData();
          message.error('查询失败');
        }
      } catch {
        if (requestId === latestRequestId) {
          clearTableData();
          message.error('查询失败');
        }
      } finally {
        if (requestId === latestRequestId) {
          loading.value = false;
        }
      }
    };
    // 搜索/重置只刷新筛选条件，不联动切换账单阶段，Tab 由用户自行选择（默认正式账单）
    const updateFiltersAndLoad = formData => {
      clearTableState();
      searchParams.value = toSearchParams(formData);
      loadAccountBills();
    };
    const handleUpdateList = () => {
      loadAccountBills();
    };
    const handlePaginationChange = (page, pageSize) => {
      pagination.value.current = page;
      pagination.value.pageSize = pageSize;
      loadAccountBills();
    };
    const handleSortChange = (sortField, ascending) => {
      if (isAccountBillSortField(sortField)) {
        if (!searchParams.value) {
          var _searchFormRef$value;
          const formData = (_searchFormRef$value = searchFormRef.value) === null || _searchFormRef$value === void 0 ? void 0 : _searchFormRef$value.getFormData();
          if (!formData) return;
          searchParams.value = toSearchParams(formData);
        }
        if (ascending === undefined) {
          delete searchParams.value.sortField;
          delete searchParams.value.ascending;
        } else {
          searchParams.value = {
            ...searchParams.value,
            sortField,
            ascending
          };
        }
        loadAccountBills();
      }
    };
    const handleSearch = formData => {
      updateFiltersAndLoad(formData);
    };
    const handleReset = formData => {
      updateFiltersAndLoad(formData);
    };
    const handleBillStageChange = billStage => {
      activeBillStage.value = billStage;
      clearTableState();
      loadAccountBills();
    };
    const getAllAccountList = list => {
      allAccountList.value = list;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SearchForm, {
        ref_key: "searchFormRef",
        ref: searchFormRef,
        onSearch: handleSearch,
        onReset: handleReset,
        onSendAccount: getAllAccountList
      }, null, 512), _createVNode(SettlementTable, {
        ref_key: "tableRef",
        ref: tableRef,
        loading: loading.value,
        data: tableData.value,
        pagination: pagination.value,
        "search-params": searchParams.value,
        "bill-stage": activeBillStage.value,
        allAccountList: allAccountList.value,
        onPaginationChange: handlePaginationChange,
        onSortChange: handleSortChange,
        onUpdateList: handleUpdateList,
        onStageChange: handleBillStageChange
      }, null, 8, ["loading", "data", "pagination", "search-params", "bill-stage", "allAccountList"])]);
    };
  }
});